export default {
  state: {
    templateData: {}
  },
  mutations: {
    setTemplateData(state, payload) {
      state.templateData = payload;
    }
  }
};
